module.exports = __webpack_public_path__ + "static/img/data2-list1.2c28e498.png";